import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'

document.addEventListener('DOMContentLoaded', function () {
  const btnConfirm = document.querySelector('.confirm-btn')
  const btnSubmit = document.querySelector('.submit-btn')
  const btnGoBack = document.querySelector('.go-back-btn')
  const form = document.querySelector('.wpcf7-form')
  const uploadWrappers = document.querySelectorAll('.codedropz-upload-handler')

  // Re-check whenever the Confirm button is clicked
  btnConfirm.addEventListener('click', function (e) {
    e.preventDefault()

    // Always validate the form
    if ($(form).valid()) {
      moveToConfirmStage()
    }
  })

  function moveToConfirmStage () {
    btnConfirm.style.display = 'none'
    btnSubmit.style.display = 'inline'
    btnGoBack.style.display = 'inline'
    // Hide all upload wrappers when in confirm screen
    uploadWrappers.forEach(wrapper => {
      wrapper.style.display = 'none'
    })

    const allElements = form.querySelectorAll('input, textarea, select')
    allElements.forEach(element => {
      const parent = element.closest('.row')
      if (parent) {
        const confirmView = parent.querySelector('.confirm-view')
        const value = element.value

        // Create a hidden field to store the original value
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = element.name
        hiddenField.value = value
        form.appendChild(hiddenField)

        if (confirmView) {
          // Update the confirm-view element with the value
          confirmView.textContent = value || '（未入力）' // Display a placeholder if the value is empty
          confirmView.classList.remove('hidden-field')
        }

        // Hide the original input elements
        element.style.display = 'none'
      }
    })
  }

  btnGoBack.addEventListener('click', function () {
    btnConfirm.style.display = 'inline'
    btnSubmit.style.display = 'none'
    btnGoBack.style.display = 'none'

    // Show all upload wrappers when clicking back
    uploadWrappers.forEach(wrapper => {
      wrapper.style.display = 'block'
    })

    const allElements = form.querySelectorAll('input, textarea, select')
    allElements.forEach(element => {
      const parent = element.closest('.row')
      if (parent) {
        const confirmViews = parent.querySelectorAll('.confirm-view')
        confirmViews.forEach((p, index) => {
          if (index === 0) {
            p.classList.add('hidden-field')
            p.textContent = ''
          } else {
            p.remove()
          }
        })
        element.style.display = ''
      }
    })

    const hiddenFields = form.querySelectorAll('input[type="hidden"]')
    hiddenFields.forEach(field => field.remove())
  })

  btnSubmit.addEventListener('click', function () {
    const allElements = form.querySelectorAll('input, textarea, select')
    allElements.forEach(element => {
      if (element.type !== 'button' && element.type !== 'submit' && element.type !== 'reset') {
        element.disabled = false
      }
    })
  })

  // Initialize jQuery Validation
  $(form).validate({
    rules: {
      'your-name': {
        required: true
      },
      email: {
        required: true,
        email: true
      },
      body: {
        required: true
      }
    },

    errorPlacement: function (error, element) {
      error.insertAfter(element)
    },
    highlight: function (element) {
      // Add a class to highlight invalid fields
      $(element).addClass('error')
    },
    unhighlight: function (element) {
      // Remove the class from valid fields
      $(element).removeClass('error')
    }
  })
})

/*
 *
 * ----------------------------------------------- */
jQuery.extend(jQuery.validator.messages, {
  required: '必須項目です',
  remote: 'このフィールドを修正してください',
  email: '有効なメールアドレスを入力してください',
  url: '有効なURLを入力してください',
  date: '有効な日付を入力してください',
  dateISO: '有効な日付（ISO）を入力してください',
  number: '有効な数字を入力してください',
  digits: '数字のみを入力してください',
  creditcard: '有効なクレジットカード番号を入力してください',
  equalTo: '同じ値をもう一度入力してください',
  extension: '有効な拡張子を含む値を入力してください',
  maxlength: jQuery.validator.format('{0} 文字以内で入力してください'),
  minlength: jQuery.validator.format('{0} 文字以上で入力してください'),
  rangelength: jQuery.validator.format(
    '{0} 文字から {1} 文字までの値を入力してください'
  ),
  range: jQuery.validator.format('{0} から {1} までの値を入力してください'),
  step: jQuery.validator.format('{0} の倍数を入力してください'),
  max: jQuery.validator.format('{0} 以下の値を入力してください'),
  min: jQuery.validator.format('{0} 以上の値を入力してください')
})

/*
 *
 * ----------------------------------------------- */
jQuery.validator.addMethod(
  'custom-email',
  function (value, element) {
    var emailArray = value.split('@')

    return (
      this.optional(element) ||
      (/^[.!#%&\-_0-9a-zA-Z?/+]+@[!#%&\-_0-9a-z]+(\.[!#%&\-_0-9a-z]+)+$/.test(
        value
      ) &&
        emailArray.length === 2)
    )
  },
  '正しいメールアドレスを入力して下さい。'
)
